import { render, staticRenderFns } from "./SettingsFootbar.vue?vue&type=template&id=3b9aed7b"
import script from "./SettingsFootbar.vue?vue&type=script&lang=js"
export * from "./SettingsFootbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports